import { render, staticRenderFns } from "./PrintProductBarcode.vue?vue&type=template&id=1be9e4c7"
import script from "./PrintProductBarcode.vue?vue&type=script&lang=js"
export * from "./PrintProductBarcode.vue?vue&type=script&lang=js"
import style0 from "./PrintProductBarcode.vue?vue&type=style&index=0&id=1be9e4c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports